//Bank Transfer
export const Bank_Transfer_Receipt = "Bank_Transfer_Receipt";
